export function getClientTrackingDebugCode(): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }

  const trackingDebugCookie = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("tracking_debug="));

  if (!trackingDebugCookie) {
    return undefined;
  }

  const value = trackingDebugCookie.slice("tracking_debug=".length);
  return value ? decodeURIComponent(value) : undefined;
}
